import { HttpInterceptorFn } from '@angular/common/http';
import { SessionService } from '../../services/session.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
const TOKEN_HEADER_KEY = 'Authorization'; 

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let authRequest = req;
  if (inject(SessionService).getLoggedIn() == true) {
    const router = inject(Router);
    const sessionService = inject(SessionService);
    const authToken = sessionService.getAccessToken();
    const reftoken = sessionService.getRefreshToken();
    const expiryTime = sessionService.getExpiryTime();
    const curdate = (new Date().getTime()/1000);
    if (curdate < expiryTime) {
      // If the token is still valid, use it
      if (authToken != '' && authToken != null && authToken !== undefined) {
        authRequest =  req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + authToken) });
      }
    } else {
      router.navigate(['/login-user']);
      sessionService.clearSession();
      // If the token has expired, use the refresh token to get a new one
      if (reftoken != '' && reftoken != null && reftoken !== undefined) {
        authRequest = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + reftoken) });
        // Optionally, you can trigger a refresh token request here
        // sessionService.refreshToken().subscribe((res: any) => {
        //   sessionService.setAccessToken(res.data.authToken);
        //   sessionService.setRefreshToken(res.data.refreshToken);
        // });
      }
    }
  }
  return next(authRequest);
};
